// Pure presence helpers for the content-browser collaboration layer (ENG-539,
// Stage 1). No Yjs / provider imports here so this stays trivially testable;
// the live provider wrapper lives in CollabPresenceClient.js.

// deriveRoster turns the set of awareness states (one per connected tab) into a
// de-duplicated list of *other* users on the character. A user with several
// tabs collapses to one entry; the most recent non-null focusedAssetId wins.
//
// states: iterable of awareness state objects, each shaped
//   { user: { id, name, color }, focusedAssetId: string|null }
// selfUserId: the local user's id, excluded from the roster.
export function deriveRoster(states, selfUserId) {
  const byUser = new Map()
  for (const st of states) {
    const u = st && st.user
    if (!u || !u.id || u.id === selfUserId) continue
    const focused = st.focusedAssetId ?? null
    const existing = byUser.get(u.id)
    if (!existing) {
      byUser.set(u.id, { userId: u.id, name: u.name || u.id, color: u.color, focusedAssetId: focused })
    } else if (focused) {
      existing.focusedAssetId = focused
    }
  }
  return [...byUser.values()]
}

// editorsByAsset groups a roster by the asset each peer is focused on, so the
// UI can show "being edited by N" on a specific asset card.
export function editorsByAsset(roster) {
  const out = {}
  for (const p of roster) {
    if (!p.focusedAssetId) continue
    ;(out[p.focusedAssetId] ||= []).push(p)
  }
  return out
}

// colorForUser is a deterministic, stable per-user colour for avatars/cursors.
export function colorForUser(userId) {
  const s = String(userId)
  let h = 0
  for (let i = 0; i < s.length; i++) h = (h * 31 + s.charCodeAt(i)) >>> 0
  return `hsl(${h % 360}, 70%, 55%)`
}

// resolveCollabUrl picks the collaboration WebSocket endpoint. Pass
// import.meta.env from the app; tests pass a plain object.
export function resolveCollabUrl(env) {
  const explicit = env && typeof env.VITE_COLLAB_URL === 'string' ? env.VITE_COLLAB_URL.trim() : ''
  if (explicit) return explicit
  return 'wss://collab-staging.avataros.xyz'
}

// roomName mirrors the server: a document is scoped as `<orgId>:<slug>`.
export function roomName(orgId, slug) {
  return `${orgId}:${slug}`
}
